var SPiD = this.SPiD || {};
SPiD.validate = SPiD.validate || {};

(function (v) {
    'use strict';

    v.getErrorElement = function (field, form) {
        return SPiD.findElements(form, '[data-errors-for]').filter(function (el) {
            return el.getAttribute('data-errors-for') === field.id;
        })[0];
    };

    v.getInput = function (field, form) {
        return SPiD.findElements(form, '[name]').filter(function (el) {
            return el.name === field.id;
        })[0] || {className: ''};
    };

    v.getInputs = function (form) {
        return SPiD.findElements(form, 'input[name]').
            concat(SPiD.findElements(form, 'textarea[name]')).
            concat(SPiD.findElements(form, 'select[name]'));
    };
}(SPiD.validate));